<script>
  import TradingViewWidget from 'svelte-tradingview-widget';

  let options = {
    symbol: 'BINANCE:BTCUSDT',
    theme: 'dark',
    height: '500px',
    width: '100%',
    locale: 'fr',
    container_id: 'options'
  };

  let options2 = {
    symbol: 'BINANCE:ETHUSDT',
    theme: 'light',
    height: '500px',
    width: '100%',
    locale: 'en',
    container_id: 'options2'
  };
</script>

<div class="bg-gray-100 border-b border-gray-200">
  <div
    class="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-12 lg:px-8 lg:flex
    lg:items-center lg:justify-between">
    <h2
      class="text-3xl leading-9 font-extrabold tracking-tight text-gray-900
      sm:text-3xl sm:leading-10">
      svelte-tradingview-widget
      <br />
      <span class="font-normal text-gray-500">
        <a
          href="https://www.tradingview.com/widget/advanced-chart/"
          class="text-indigo-600">
          [TradingView Advanced Real-Time Chart Widget]
        </a>
        <br />
        Svelte component for rendering the TradingView Advanced Real-Time Chart
        Widget
      </span>
      <div class="flex mt-4">
        <img
          src="https://img.shields.io/npm/v/svelte-tradingview-widget.svg?style=for-the-badge"
          alt="svelte-tradingview-widget npm" />
        <img
          src="https://img.shields.io/github/license/mashape/apistatus.svg?style=for-the-badge"
          alt="svelte-tradingview-widget license"
          class="ml-1" />
        <img
          src="https://img.shields.io/npm/dt/svelte-tradingview-widget.svg?style=for-the-badge"
          alt="svelte-tradingview-widget downloads"
          class="ml-1" />
      </div>
    </h2>
    <div class="mt-8 flex lg:flex-shrink-0 lg:mt-0">
      <div class="inline-flex rounded-md shadow">
        <a
          href="https://github.com/borakilicoglu/svelte-tradingview-widget"
          class="inline-flex items-center justify-center px-5 py-1 border
          border-transparent text-base leading-6 font-medium rounded-md
          text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none
          focus:shadow-outline transition duration-150 ease-in-out">
          Github
        </a>
      </div>
    </div>
  </div>
</div>

<div
  class="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-12 lg:px-8 lg:flex-row
  overflow-x-auto lg:items-center lg:justify-between">

  <h2
    class="text-3xl leading-9 font-normal tracking-tight mb-4 sm:text-3xl
    sm:leading-10">
    Props
  </h2>

  <p class="font-normal text-gray-500">
    You can easily create your own properties from
    <a
      href="https://www.tradingview.com/widget/advanced-chart/"
      class="font-normal text-indigo-600">
      here
    </a>
    then you can pass them to your component.
  </p>
</div>

<div class="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-12 lg:px-8">
  <h2
    class="text-3xl leading-9 font-normal tracking-tight mb-4 sm:text-3xl
    sm:leading-10">
    Demo Dark
  </h2>

  <TradingViewWidget {options} />
</div>

<div class="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-12 lg:px-8">
  <h2
    class="text-3xl leading-9 font-normal tracking-tight mb-4 sm:text-3xl
    sm:leading-10">
    Demo Light
  </h2>
  <TradingViewWidget options={options2} />
</div>
